import { cn } from "@/lib/cn";
import type { ApprovalStatus } from "@/types/database";

const LABELS: Record<ApprovalStatus | "none", string> = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  none: "No application",
};

const STYLES: Record<ApprovalStatus | "none", string> = {
  pending: "bg-[#fff4e5] text-[#b45309]",
  approved: "bg-accent-subtle text-accent-foreground",
  rejected: "bg-orange-50 text-orange-700",
  none: "bg-canvas text-muted",
};

export function StatusBadge({
  status,
  className,
}: {
  status: ApprovalStatus | "none";
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide",
        STYLES[status],
        className
      )}
    >
      {LABELS[status]}
    </span>
  );
}
